import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import NoteAddIcon from "@mui/icons-material/NoteAdd";
import { Box, IconButton, Stack, CircularProgress } from "@mui/material";
import {
  MRT_GlobalFilterTextField,
  useMaterialReactTable,
} from "material-react-table";
import { useEffect, useMemo, useState } from "react";
import {
  AlertDialog,
  MgpButton,
  MgpModal,
  MgpTable,
  MgpText,
  TableConfig,
} from "../../../components/global";
import { Tooltip } from "@mui/material";
import { useRbac, useRoles } from "../../../hooks";
import { UpdateRoles } from "./UpdateRoles";
import Loader from "../../Loader/Loader";
import MgpAlertBar from "../../../components/global/MgpAlertBar";
import { ENV } from "../../../helpers";
import { downloadPdf } from "../../../helpers/dowloadPdf.js";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { downloadExcel } from "../../../helpers/downloadExcel.js";

export const Roles = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [delete_ref, setDeleting] = useState(false);
  const { useGetRoles, useDeleteRole } = useRoles();
  const [edit, setEdit] = useState({});
  const { RbacWrapper, getActionRbac } = useRbac();
  const [GetRoles, { data, loading, error }] = useGetRoles;
  const [DeleteRole] = useDeleteRole;
  const [message, setMessage] = useState("");
  const [alertType, setAlertType] = useState("");
  const [alertOption, setAlertOption] = useState(false);
  const [mainPageloading, setMainPageloading] = useState(true);
  const handleNew = () => {
    setEdit({});
    setOpen(true);
  };
  const handleSubmitClose = () => {
    setAlertOption(false);
  };
  const handleExportData = (type) => {
    const filteredData = table
      .getFilteredRowModel()
      .rows.map((row) => row.original)
      .map((obj) => {
        const filteredObj = {};
        columns.forEach((key) => {
          if (obj.hasOwnProperty(key.accessorKey)) {
            filteredObj[key.header] = obj[key.accessorKey];

          }
        });
        return filteredObj;
      });
    let dataToExport = filteredData ? filteredData : data.rows;
    let filename = "Roles List MG";
    if (dataToExport.length) {
      if (type === "xlsx") {
        downloadExcel(dataToExport, filename)
      } else {
        downloadPdf(dataToExport, filename);
      }
    }
  };
  useEffect(() => {
    GetRoles();
  }, [GetRoles]);

  useEffect(() => {
    if (data || error) {
      setMainPageloading(false);
      setTimeout(() => {
        setIsLoading(false);
      }, 1000);
    }
  }, [data, error]);
  const columns = useMemo(
    () => [
      {
        accessorKey: "role_name",
        header: "Role",
      },
      {
        accessorKey: "created_on", //normal accessorKey
        header: "Created On",
      },
    ],
    []
  );

  const table = useMaterialReactTable({
    columns,
    data: data?.GetRoles ?? [],
    ...TableConfig,
    enableRowActions: true,
    muiSearchTextFieldProps: {
      size: "small",
      variant: "outlined",
    },

    renderTopToolbar: ({ table }) => (
      <Box
        sx={(theme) => ({
          display: "flex",
          gap: "0.5rem",
          p: "16px 0px",
          justifyContent: "space-between",
        })}
      >
        <Box sx={{ display: "flex", gap: "0.5rem", alignItems: "center" }}>
          <MRT_GlobalFilterTextField table={table} />
        </Box>
        <Box sx={{ display: "flex", gap: "16px" }}>
          <RbacWrapper module={"roles"} code={"add"}>
            <MgpButton
              variant="contained"
              onClick={handleNew}
              endIcon={<NoteAddIcon sx={{ marginTop: "-3px", fontSize: "16px !important" }} />}
            >
              Add New Role
            </MgpButton>
          </RbacWrapper>
          <MgpButton
            //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
            onClick={() => handleExportData('xlsx', "table")}
            endIcon={<FileDownloadIcon sx={{ fontSize: "16px !important" }} />}
            variant="contained"
          >
            Export Excel
          </MgpButton>
          <MgpButton
            //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
            onClick={() => handleExportData('pdf', "table"
            )}
            endIcon={<FileDownloadIcon sx={{ fontSize: "16px !important" }} />}
            variant="contained"
          >
            Export PDF
          </MgpButton>
        </Box>
      </Box>
    ),
    renderRowActions: ({ row }) => {
      return (
        <>
          <RbacWrapper module={"roles"} code={"edit"}>
            <Tooltip title={"Edit Role"} arrow>
              <IconButton
                size="small"
                onClick={() => {
                  setEdit(row.original);
                  setOpen(true);
                }}
              >
                <EditIcon sx={{ height: "16px" }} />
              </IconButton>
            </Tooltip>
          </RbacWrapper>
          <RbacWrapper module={"roles"} code={"delete"}>
            <Tooltip title={"Delete Role"} arrow>
              <IconButton
                size="small"
                onClick={() => {
                  handleDelete(row.original);
                }}
              >
                <DeleteIcon sx={{ height: "16px" }} />
              </IconButton>
            </Tooltip>
          </RbacWrapper>
        </>
      );
    },
    state: { isLoading, columnOrder: columns.map((e) => e.accessorKey) },
    renderTableBody: () => {
      return isLoading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100px",
          }}
        >
          <CircularProgress />
        </Box>
      ) : null;
    },
  });

  const handleDelete = (row) => {
    setDeleting(row.role_id);
  };
  if (mainPageloading) {
    return <Loader open={mainPageloading} />;
  }
  return (
    <>
      {delete_ref && (
        <AlertDialog
          open={true}
          negative={() => {
            setDeleting(false);
          }}
          positive={(param) => {
            setMainPageloading(true)
            DeleteRole({
              variables: { roleId: Number(param) }, onCompleted: () => {
                setDeleting(false);
                setMainPageloading(false)
                setAlertType("success")
                setAlertOption(true)
                setMessage("Roles Removed Successfully")
              }
            });
          }}
          param={delete_ref}
          title={"Role Deletion"}
          description={"Are you sure you want to delete this role?"}
        />
      )}

      <MgpModal
        title={edit.role_id ? "Update Role" : "Add Role"}
        open={open}
        onClose={() => {
          setOpen(false);
        }}
      >
        <UpdateRoles
          setAlertOption={setAlertOption}
          setMainPageloading={setMainPageloading}
          setAlertType={setAlertType}
          setMessage={setMessage}
          edit={edit}
          closed={() => {
            setOpen(false);
          }}
        />
      </MgpModal>

      <Stack>
        <MgpText variant="h5">ROLE LIST</MgpText>
        <MgpTable table={table} />
      </Stack>
      <MgpAlertBar
        open={alertOption}
        setOpen={handleSubmitClose}
        alertType={alertType}
        message={message}
      />
    </>
  );
};
